(function() {
  'use strict';

  function applyFilterUrl(url) {
    if (!url) return;
    if (typeof window.ajaxfilter === 'function') {
      window.ajaxfilter(url);
      return;
    }
    window.location.href = url;
  }

  function closeAllPanels(root) {
    if (!root) return;
    root.querySelectorAll('[aria-expanded="true"]').forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('.plp-facets__panel:not([hidden])').forEach(function(panel) {
      panel.hidden = true;
    });
  }

  function updateDrawerBodyClass(root) {
    var hasActiveDrawer = root && root.querySelector('.plp-facets__drawer.is-open, .plp-facets__drawer.is-closing');
    if (!hasActiveDrawer) {
      document.body.classList.remove('plp-facets-drawer-open');
    }
  }

  function closeDrawer(drawer, root, immediate) {
    if (!drawer || drawer.hidden) return;
    if (drawer.classList.contains('is-closing')) return;

    var panel = drawer.querySelector('.plp-facets__drawer-panel');
    var finishClose = function() {
      drawer.classList.remove('is-closing');
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      updateDrawerBodyClass(root);
    };

    if (immediate || !panel) {
      drawer.classList.remove('is-open');
      finishClose();
      return;
    }

    drawer.classList.add('is-closing');
    drawer.classList.remove('is-open');

    var closed = false;
    var onEnd = function(event) {
      if (closed || event.target !== panel || event.propertyName !== 'transform') return;
      closed = true;
      panel.removeEventListener('transitionend', onEnd);
      finishClose();
    };

    panel.addEventListener('transitionend', onEnd);
    window.setTimeout(function() {
      if (!closed) {
        closed = true;
        panel.removeEventListener('transitionend', onEnd);
        finishClose();
      }
    }, 400);
  }

  function closeAllDrawers(root, immediate) {
    if (!root) return;
    root.querySelectorAll('.plp-facets__drawer').forEach(function(drawer) {
      if (!drawer.hidden || drawer.classList.contains('is-open') || drawer.classList.contains('is-closing')) {
        closeDrawer(drawer, root, immediate);
      }
    });
  }

  function openDrawer(drawer, root) {
    if (!drawer) return;
    closeAllDrawers(root, true);
    closeAllPanels(root);
    drawer.hidden = false;
    drawer.classList.remove('is-closing');
    document.body.classList.add('plp-facets-drawer-open');

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
      });
    });
  }
  function updateSortLabels(root, label, isActive) {
    if (!root || !label) {
      return;
    }

    root.querySelectorAll('.plp-facets__sort-current').forEach(function(el) {
      el.textContent = label;
    });

    root.querySelectorAll('[data-plp-sort-toggle], [data-plp-sort-drawer-open]').forEach(function(btn) {
      btn.classList.toggle('is-active', !!isActive);
    });
  }

  function applySort(value, root, label) {
    var url = new URL(window.location.href);
    var sortSelect = document.getElementById('SortBy');
    var defaultSort = document.querySelector('.collection-header__default-sort');
    var defaultValue = defaultSort ? defaultSort.value : '';

    if (value && value !== defaultValue) {
      url.searchParams.set('sort_by', value);
    } else {
      url.searchParams.delete('sort_by');
    }

    if (sortSelect) {
      sortSelect.value = value || defaultValue;
    }

    if (root && label) {
      var isActive = value && value !== defaultValue;
      updateSortLabels(root, isActive ? label : 'Sort By', isActive);
    }

    applyFilterUrl(url.pathname + url.search);
  }

  function buildTagFilterUrl(root) {
    var collectionUrl = root.getAttribute('data-collection-url');
    var checked = root.querySelectorAll('.plp-facets__tag-input:checked');
    var tags = [];

    checked.forEach(function(input) {
      if (input.value) tags.push(input.value);
    });

    if (!tags.length) {
      return collectionUrl + window.location.search;
    }

    return collectionUrl + '/' + tags.join('+') + window.location.search;
  }

  function bindTagCheckboxes(root) {
    root.querySelectorAll('.plp-facets__tag-input').forEach(function(input) {
      if (input.dataset.plpTagBound === 'true') return;
      input.dataset.plpTagBound = 'true';

      input.addEventListener('change', function() {
        var label = input.closest('.plp-facets__tag-option, .plp-facets__color-option');
        if (label) {
          label.classList.toggle('is-checked', input.checked);
        }
        applyFilterUrl(buildTagFilterUrl(root));
      });
    });
  }

  function bindPriceApply(root) {
    root.querySelectorAll('[data-price-apply]').forEach(function(button) {
      if (button.dataset.plpPriceBound === 'true') return;
      button.dataset.plpPriceBound = 'true';

      button.addEventListener('click', function() {
        var wrap = button.closest('[data-price-filter]');
        if (!wrap) return;

        var minInput = wrap.querySelector('[data-price-min]');
        var maxInput = wrap.querySelector('[data-price-max]');
        var url = new URL(window.location.href);

        if (minInput && minInput.name) {
          if (minInput.value) {
            url.searchParams.set(minInput.name, minInput.value);
          } else {
            url.searchParams.delete(minInput.name);
          }
        }

        if (maxInput && maxInput.name) {
          if (maxInput.value) {
            url.searchParams.set(maxInput.name, maxInput.value);
          } else {
            url.searchParams.delete(maxInput.name);
          }
        }

        applyFilterUrl(url.pathname + url.search);
      });
    });
  }

  var toastTimer = null;

  function hideFilterToast(root) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var toast = document.getElementById('PLPFilterToast-' + sectionId);
    if (!toast) return;
    toast.classList.remove('is-visible');
    toast.hidden = true;
    if (toastTimer) {
      window.clearTimeout(toastTimer);
      toastTimer = null;
    }
  }

  function showFilterToast(root) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var toast = document.getElementById('PLPFilterToast-' + sectionId);
    if (!toast) return;

    toast.hidden = false;
    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    if (toastTimer) {
      window.clearTimeout(toastTimer);
    }
    toastTimer = window.setTimeout(function() {
      hideFilterToast(root);
    }, 6000);
  }

  function hasActivePriceFilterInUrl() {
    var url = new URL(window.location.href);
    var hasPrice = false;
    url.searchParams.forEach(function(value, key) {
      if (key.indexOf('filter.') === 0 && key.toLowerCase().indexOf('price') !== -1) {
        hasPrice = true;
      }
    });
    return hasPrice;
  }

  function checkEmptyPriceFilterResults(root) {
    if (!root) return;
    var count = parseInt(root.getAttribute('data-products-count'), 10);
    if (isNaN(count)) {
      count = document.querySelectorAll('.productList .grid-products .grid__item, .productList .list-view-items .list-view-item').length;
    }

    if (count === 0 && hasActivePriceFilterInUrl()) {
      showFilterToast(root);
    } else {
      hideFilterToast(root);
    }
  }

  function bindToastClose(root) {
    var sectionId = root.getAttribute('data-section-id');
    var toast = document.getElementById('PLPFilterToast-' + sectionId);
    if (!toast || toast.dataset.plpToastBound === 'true') return;
    toast.dataset.plpToastBound = 'true';

    toast.querySelectorAll('[data-plp-toast-close]').forEach(function(button) {
      button.addEventListener('click', function() {
        hideFilterToast(root);
      });
    });
  }

  function initPLPFacets(root) {
    if (!root || root.dataset.plpBound === 'true') return;
    root.dataset.plpBound = 'true';

    var filterDrawer = root.querySelector('.plp-facets__drawer:not(.plp-facets__sort-drawer)');
    var sortDrawer = root.querySelector('.plp-facets__sort-drawer');

    root.addEventListener('click', function(event) {
      var filterLink = event.target.closest('[data-plp-filter-url]');
      if (filterLink) {
        event.preventDefault();
        closeAllDrawers(root);
        applyFilterUrl(filterLink.getAttribute('href'));
        return;
      }

      var sortOption = event.target.closest('[data-sort-value]');
      if (sortOption && root.contains(sortOption)) {
        event.preventDefault();
        var sortLabel = sortOption.textContent.trim();
        applySort(sortOption.getAttribute('data-sort-value'), root, sortLabel);
        root.querySelectorAll('.plp-facets__sort-option').forEach(function(option) {
          option.classList.toggle('is-active', option === sortOption);
        });
        closeAllPanels(root);
        closeAllDrawers(root);
        return;
      }

      var sortToggle = event.target.closest('[data-plp-sort-toggle]');
      if (sortToggle && root.contains(sortToggle)) {
        event.preventDefault();
        var isOpen = sortToggle.getAttribute('aria-expanded') === 'true';
        var panelId = sortToggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;

        closeAllPanels(root);
        closeAllDrawers(root);

        if (!isOpen && panel) {
          sortToggle.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
        return;
      }

      var toggle = event.target.closest('.plp-facets__toggle');
      if (toggle && root.contains(toggle) && !toggle.hasAttribute('data-plp-sort-toggle')) {
        event.preventDefault();
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        closeAllPanels(root);
        closeAllDrawers(root);

        if (!isOpen && panel) {
          toggle.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
        return;
      }

      if (event.target.closest('[data-plp-drawer-open]')) {
        openDrawer(filterDrawer, root);
        return;
      }

      if (event.target.closest('[data-plp-sort-drawer-open]')) {
        openDrawer(sortDrawer, root);
        return;
      }

      if (event.target.closest('[data-plp-drawer-close]')) {
        var drawerToClose = event.target.closest('.plp-facets__drawer');
        closeDrawer(drawerToClose, root);
      }
    });

    document.addEventListener('click', function(event) {
      if (!root.contains(event.target)) {
        closeAllPanels(root);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeAllPanels(root);
        closeAllDrawers(root);
      }
    });

    bindTagCheckboxes(root);
    bindPriceApply(root);
    bindToastClose(root);
    checkEmptyPriceFilterResults(root);
  }

  function initAllPLPFacets() {
    document.querySelectorAll('.plp-facets').forEach(initPLPFacets);
  }

  window.PLPFacets = {
    init: initAllPLPFacets,
    refresh: function() {
      document.querySelectorAll('.plp-facets').forEach(function(root) {
        delete root.dataset.plpBound;
        initPLPFacets(root);
      });
    },
    checkEmptyPriceFilterResults: checkEmptyPriceFilterResults
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPLPFacets);
  } else {
    initAllPLPFacets();
  }

  document.addEventListener('shopify:section:load', function() {
    initAllPLPFacets();
  });
})();
